export function Funnel(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M51.4662 0H2.53419C0.285809 0 -0.848718 2.72805 0.744387 4.32116L20.25 23.8297V45.5625C20.25 46.3884 20.653 47.1624 21.3297 47.6362L29.7672 53.5403C31.4318 54.7056 33.75 53.5246 33.75 51.4666V23.8297L53.2561 4.32116C54.8459 2.73122 53.7192 0 51.4662 0Z" />
    </svg>
  );
}
